<template>
<div class="card card-custom" v-loading="loading">
    <div class="card-body">
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
            <div class="mr-7 mb-4">
                <el-image class="symbol symbol-50 symbol-lg-150 symbol-fixed position-relative" :src="'https://www.perufedup.com/wp-content/uploads/2019/03/Wushu_1_.png'" lazy></el-image>
            </div>
            <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start flex-wrap">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center">
                            <div class="text-gray-900 text-hover-primary font-size-h2 font-weight-bolder mr-1" v-text="'Oficiales Administrativos'"></div>
                            <el-popover placement="top" :width="200" trigger="hover">
                                <template #reference>
                                    <div :class="'btn btn-sm btn-light-success ml-2 py-1 px-3'">Disponible</div>
                                </template>
                                <p >Inscripciones habilitadas hasta el <b>2022-02/02</b></p>
                            </el-popover>
                        </div>
                        <div class="d-flex flex-wrap font-weight-bold font-size-h6 mb-4 pr-2">
                            <span class="d-flex align-items-center mr-5 mb-2">
                                El registro es único y a nivel de evento
                            </span>
                        </div>
                    </div>
                    <div class="d-flex my-4">
                        <div class="btn btn-sm btn-primary mr-3">Registrar</div>
                        <div class="btn btn-sm btn-info mr-3">Finalizar Inscripción</div>
                        <el-dropdown>
                            <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                <i class="fa fa-ellipsis-h text-dark" aria-hidden="true"></i>
                            </button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item>Ficha Nominal</el-dropdown-item>
                                    <el-dropdown-item>Observaciones</el-dropdown-item>
                                </el-dropdown-menu>
                                <!--consolidateFN(1)-->
                            </template>
                        </el-dropdown>
                    </div>
                </div>

                <div class="d-flex flex-wrap flex-stack">
                    <div class="d-flex flex-column flex-grow-1 pe-8">
                        <div class="d-flex flex-wrap">
                            <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mr-6 mb-3">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-users icon-2x mr-2" aria-hidden="true"></i>
                                    <div class="font-size-h2 font-weight-bolder counted" v-text="12"></div>
                                </div>
                                <div class="font-weight-bold font-size-h6">Registrados</div>
                            </div>

                            <div  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mr-6 mb-3">
                                <div class="d-flex align-items-center">
                                    <i :class="'fa fa-child icon-2x mr-2'" aria-hidden="true"></i>
                                    <div class="font-size-h2 font-weight-bolder counted" v-text="11"></div>
                                </div>
                                <div class="font-weight-bold" v-text="'Varones'"></div>
                            </div>

                            <div  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mr-6 mb-3">
                                <div class="d-flex align-items-center">
                                    <i :class="'fa fa-child icon-2x mr-2'" aria-hidden="true"></i>
                                    <div class="font-size-h2 font-weight-bolder counted" v-text="20"></div>
                                </div>
                                <div class="font-weight-bold" v-text="'Damas'"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-start flex-wrap mb-4">
            <div class="d-flex align-items-center position-relative">
                <span class="svg-icon svg-icon-1 position-absolute ml-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                    </svg>
                </span>
                <input type="text" class="form-control form-control-solid w-250px pl-12" placeholder="Buscar...">
            </div>
            <sumaryStatus></sumaryStatus>
        </div>

        <el-table ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChange" height="400" style="width: 100%">
            
            <el-table-column property="date" label="PARTICIPANTE" width="120">
            </el-table-column>
            <el-table-column property="name" label="DOCUMENTO" width="120">
            </el-table-column>
            <el-table-column property="address" label="SEXO"> </el-table-column>
            <el-table-column property="address" label="FUNCIÓN"> </el-table-column>
            <el-table-column property="address" label="REGISTRADO"> </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" v-model:currentPage="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
        </el-pagination>





    </div>
</div>

</template>

<script>
import sumaryStatus from "@/components/shared/sumaryStatus";

export default {
    name: 'Administrative',
    components: {
        sumaryStatus
    },
    data: () => ({
        loading: false,
        tableData: [{
                date: '2016-05-03',
                name: 'Tom',
                address: 'No. 189, Grove St, Los Angeles',
            },
            {
                date: '2016-05-02',
                name: 'Tom',
                address: 'No. 189, Grove St, Los Angeles',
            },
            {
                date: '2016-05-04',
                name: 'Tom',
                address: 'No. 189, Grove St, Los Angeles',
            },
            {
                date: '2016-05-01',
                name: 'Tom',
                address: 'No. 189, Grove St, Los Angeles',
            }
        ],
        currentRow: null,
        currentPage4: 4
    }),
    methods: {
        /*handleCurrentChange() {
            this.currentRow = val
        },*/
        getNominal(){
            this.loading = true;

        },
        handleSizeChange(val) {
            console.log(`${val} items per page`)
        },
        handleCurrentChange(val) {
            console.log(`current page: ${val}`)
        }
    },
    created(){
        this.getNominal();
    }

}
</script>
